module.exports = __webpack_public_path__ + "static/media/mediator.8cf0068f.png";